export default [
    {
        text: '工作台',
        name: 'home',
        path: '/home',
        icon: 'iconfont icon-menu_kongzhitai',
        isFold: false
    },{
        text: '订单管理',
        name: 'order',
        icon: 'iconfont icon-5',
        isFold: true,
        children:[
            {
                text: '订单管理',
                name: 'order-list',
                path: '/order/list',
            },{
                text: '订单统计',
                name: 'order-statistics',
                path: '/order/statistics',
            },
        ]
    },
    {
        text: '商品管理',
        name: 'shop',
        icon: 'iconfont icon-shangpin-tianchong',
        isFold: true,
        children:[
            {
                text: '商品分类',
                name: 'shop-group',
                path: '/shop/group',
            },{
                text: '添加商品',
                name: 'shop-add',
                path: '/shop/add',
            },{
                text: '商品列表',
                name: 'shop-list',
                path: '/shop/list',
            },
        ]
    },{
        text: '库存管理',
        name: 'stock',
        icon: 'iconfont icon-kucun_crm',
        isFold: true,
        children:[
            {
                text: '添加库存',
                name: 'stock-add',
                path: '/stock/add',
            },{
                text: '库存列表',
                name: 'stock-list',
                path: '/stock/list',
            },
        ]
    },
    {
        text: '营销管理',
        name: 'sales',
        icon: 'iconfont icon-yingxiaogongju-zhututubiao',
        isFold: true,
        children:[
            {
                text: '折扣活动',
                name: 'sales-discount',
                path: '/sales/discount',
            },
            // {
            //     text: '优惠券',
            //     name: 'sales-coupon',
            //     path: '/sales/coupon',
            // }
        ]
    },
    {
        text: '系统设置',
        name: 'setting',
        icon: 'iconfont icon-shezhi',
        isFold: true,
        children:[
            {
                text: '基础配置',
                name: 'setting-base',
                path: '/setting/base',
            },{
                text: '主题配置',
                name: 'setting-theme',
                path: '/setting/theme',
            },{
                text: '邮箱配置',
                name: 'setting-email',
                path: '/setting/email',
            },{
                text: '短信配置',
                name: 'setting-sms',
                path: '/setting/sms',
            },{
                text: '上传配置',
                name: 'setting-upload',
                path: '/setting/upload',
            },{
                text: '支付配置',
                name: 'setting-pay',
                path: '/setting/pay',
            },{
                text: '轮播图配置',
                name: 'setting-swipe',
                path: '/setting/swipe',
            }
        ]
    },
    
];
